import React from 'react';
import { FormControl, TextField } from '@material-ui/core';
import InputMask from 'react-input-mask';

import { ControlContainer } from 'app/components/ControlContainer';
import { ZipCodeMaskedControlProps } from './ZipCodeMaskedControl.interfaces';
import { DoneAdornment } from 'app/components/DoneAdornment';
import isLabelFitToInput from 'app/shared/helpers/isLabelFitToInput';
import { LabelEnum } from 'app/shared/enums';
import { useZipCodeControl } from 'app/shared/hooks/controls/useZipCodeControl';

export default function ZipCodeMaskedControl(props: ZipCodeMaskedControlProps) {
  const {
    disabled,
    helperText,
    input,
    label,
    meta,
    subLabel,
    tooltip,
    width,
    placeholder,
    duplicateLabel,
    labelAboveInputField,
  } = props;

  const {
    error,
    focused,
    handleBlur,
    handleChange,
    handleClick,
    isValueCheckVisible,
    localValue,
    mask,
    maskChar,
    onFocus,
  } = useZipCodeControl(props);

  return (
    <ControlContainer
      inputId={input.name}
      tooltip={tooltip}
      subLabel={subLabel}
      helperText={helperText}
      meta={meta}
      focused={focused}
      width={width || 'xs'}
      label={
        duplicateLabel
          ? label
          : labelAboveInputField
          ? label
          : !isLabelFitToInput(label, width)
          ? label
          : ''
      }
    >
      <FormControl fullWidth>
        <InputMask
          mask={mask}
          maskChar={maskChar}
          value={localValue}
          onChange={handleChange}
          onBlur={handleBlur}
          onFocus={onFocus}
        >
          {() => (
            <TextField
              id={input.name}
              InputProps={{
                startAdornment: isValueCheckVisible && <DoneAdornment />,
                disabled: disabled,
                name: input.name,
              }}
              label={
                duplicateLabel
                  ? placeholder
                  : !labelAboveInputField && isLabelFitToInput(label, width)
                  ? label
                  : ''
              }
              onClick={handleClick}
              error={error}
              variant={'outlined'}
              margin={'dense'}
              placeholder={placeholder || LabelEnum.ZipCodePlaceholder}
              type="tel"
            />
          )}
        </InputMask>
      </FormControl>
    </ControlContainer>
  );
}
